import Skeleton from "@mui/material/Skeleton";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Wrapper, ImagesWrapper, GalleryImageWrapper } from "./ProductGalleryLayoutComponents";

const GalleryImageWrapperSkeleton = styled(GalleryImageWrapper)({
    backgroundColor: "transparent",
    cursor: "default",
});

export function ProductGallerySkeleton() {
    const theme = useTheme();
    const isDownLg = useMediaQuery(theme.breakpoints.down("lg"));
    const items = new Array(isDownLg ? 1 : 6).fill(undefined);

    return (
        <Wrapper>
            <ImagesWrapper data-single-image="false">
                {items.map((_, index) => {
                    const width = index === 0 || isDownLg ? "100%" : "100px";
                    const height = index === 0 || isDownLg ? "100%" : "80px";
                    return (
                        <GalleryImageWrapperSkeleton key={index}>
                            <Skeleton variant="rectangular" width={width} height={height} />
                        </GalleryImageWrapperSkeleton>
                    );
                })}
            </ImagesWrapper>
        </Wrapper>
    );
}
